module.exports = __webpack_public_path__ + "assets/img/GESTIONDEPEDIDOS_1.ea951fbe.svg";